import { render, staticRenderFns } from "./RankingFarmacia.vue?vue&type=template&id=de754038&scoped=true&"
import script from "./RankingFarmacia.vue?vue&type=script&lang=js&"
export * from "./RankingFarmacia.vue?vue&type=script&lang=js&"
import style0 from "./RankingFarmacia.vue?vue&type=style&index=0&id=de754038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de754038",
  null
  
)

export default component.exports